import { moduleForDisplayMode } from './module-for-display-mode'

export default function whatsHappeningModule(
  entries,
  storeName,
  centre,
  analyticsMetadata
) {
  return moduleForDisplayMode(centre, {
    displayMode: 'WhatsHappeningSpotlight',
    title: `What's happening at ${storeName}`,
    entries,
    analyticsMetadata,
  })
}
